export class ContextDocumentUploadError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ContextDocumentUploadError';
  }
}

export function getContextDocumentUploadErrorMessage(error: unknown): string {
  const message =
    error instanceof Error
      ? error.message
      : error && typeof error === 'object' && 'message' in error
        ? String(error.message)
        : '';

  if (/invalid input syntax for type uuid/i.test(message)) {
    return 'Could not save the source document. Refresh the page and try again.';
  }
  if (/row-level security|access denied|unauthorized/i.test(message)) {
    return 'Your session does not allow uploads. Refresh the page and sign in again.';
  }

  return message.trim() || 'Unable to upload this document.';
}
